import {Observable} from 'rxjs';

export enum ElementStatus {
	valid = 1, invalid, pending, disabled, untouched,
}

export type ValidatorArgs<T> = {
	readonly field: {
		readonly currentValue: T,
		readonly parentControl?: IFormControl<T>,
	},
	errors: string[],
	cancelled: boolean,
}
export type Validator<T> = (validationChain: Observable<ValidatorArgs<T>>) => Observable<ValidatorArgs<T>>;

export type ControlOptions<T> = {
	validators?: Validator<T | any>[],
	initialValidateStatus?: ElementStatus;
	disableValueComparison?: boolean;
};

export type ValidationResult = string[];

export type FormValidationResult<T> = ValidationResult & {
	valid: boolean;
	fields: {
		[P in keyof T]: ValidationResult;
	};
};

export type Controls = {
	[key: string]: IFormControl | IFormGroup;
}

export type ControlValue<T> = {
	[P in keyof T]: T[P] extends IFormGroup<infer R> ? ControlValue<R> : T[P] extends IFormControl<infer R> ? R : never;
};

export type ControlFluentFields<T> = {
	status: ElementStatus;
	value: T;
}

export type FormControlChangedArgs<T> = {
	reason: keyof ControlFluentFields<T>;
	prevState: ControlFluentFields<T>;
	currState: ControlFluentFields<T>;
}

export interface IFormControl<T = any> extends ControlFluentFields<T> {
	validate(silence?: boolean): Observable<ValidationResult>;

	validators: Validator<T>[];

	hasError(error?: string): boolean;

	firstError(): string;

	onChanged: Observable<FormControlChangedArgs<T>>;
}

export interface IFormGroup<T = any, S = any> extends ControlFluentFields<S> {
	controls: T;

	validate(silence?: boolean): Observable<FormValidationResult<S>>;

	onChanged: Observable<FormControlChangedArgs<S>>;
}
